import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core'
import {provideRouter, withInMemoryScrolling} from '@angular/router'
import {routes} from './app.routes'
import {provideAnimations} from '@angular/platform-browser/animations'
import {getAuth, provideAuth} from '@angular/fire/auth'
import {getFirestore, provideFirestore} from '@angular/fire/firestore'
import {getStorage, provideStorage} from '@angular/fire/storage'
import {environment} from '@environments/environment'
import {initializeApp, provideFirebaseApp} from '@angular/fire/app'
import {TitleService} from '@shared/services/title.service'
import {ClassWatcherService} from '@shared/services/class-watcher.service'
import {ThemeService} from '@shared/services/theme.service'
import {registerLocaleData} from '@angular/common'
import localeFr from '@angular/common/locales/fr'
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'

registerLocaleData(localeFr)

export const appConfig: ApplicationConfig = {
  providers: [
    TitleService,
    ClassWatcherService,
    ThemeService,

    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideAnimations(),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),

    {provide: LOCALE_ID, useValue: 'fr-FR'},
    provideAnimationsAsync(),
  ],

}

